module.exports = __webpack_public_path__ + "static/media/ic_head1.af54eada.png";